<template>
    <div class="layer aboutUs">
            <div style="width: 75%;" class="card">
                <button title="Close window" @click="closeTheWindowAbout">
                    <!--  onclick="$(this).parent().parent().fadeOut(300);" -->
                 <i class="fas fa-plus"></i></button>
                <h2> حول </h2>
                <br>
                <!-- <p>
                        تم تصميم هذا الموقع البيسط لمساعدة المسلمين لمعرفة أوقات الصلوات في جميع انحاء العالمو كما يوجد به بعض من الأحاديث الصحيحة و أذكار الصباح و المساءو كما يوجد به مصحف مرئي
                        <br>
                        ارجوا ان هذه الموقع أن ينال إعجابكم ;)
                    </p> -->
                <p>
                    <center> موقع صلاتي الإسلامي </center>
                    يوفر موقعنا أوقات الصلوات الخمسة في جميع انحاء العالم كما يتوفر به التقويم الهجري و الميلادي مع تواريخ
                    االمناسبات الإسلامية, يقدم موقع صلاتي الإسلامي أيضا مجموعة من الأدكار اليومية مقسمة بحسب اوقات قرئتها
                    <br>
                    نسئل الله ان يكون هذا الموقع مفيد لكل المسلمين و أن يكون صدقة جارية لكل من ساهم في بنائه ولو بفكرة صغيرة
                    <br>
                    والسلام عليكم ورحمة الله وباركاته
                </p>
                <br>
                <p style="text-align: center;opacity: 0.4;"> الإصدار <span id="idVarsion">1.3</span> </p>
            </div>
        </div>
</template>

<script>
export default {
    methods: {
        closeTheWindowAbout() {
            this.$emit("closeAbout", false);
        }
    }
} 
</script>